import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "nerriPasswordRuleIcon"
})
export class PasswordRuleIconPipe implements PipeTransform {
    public transform(rule: boolean | null): string {
        if (rule === null) {
            return "streamline-regular:subtract";
        }

        if (rule) {
            return "streamline-regular:check-1";
        }

        return "streamline-regular:close";
    }
}
